import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const thingsToKnowAboutContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    description: z.string(),
    items: z.array(
      z.object({
        title: z.string(),
        description: z.string(),
        url: z.string(),
        image: z.string(),
      })
    ),
  }),
});

export const contentTypeThingsToKnowAboutContentSchema = contentBase.extend({
  content: thingsToKnowAboutContentSchema,
});

export type ContentTypeThingsToKnowAboutContentInput = z.infer<
  typeof contentTypeThingsToKnowAboutContentSchema
>;
